// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountCategoryDto
 */
export interface IAccountCategoryDto {
    /**
     * 
     * @type {number}
     * @memberof IAccountCategoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountCategoryDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IAccountCategoryDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IAccountCategoryDto interface.
 */
export function instanceOfIAccountCategoryDto(value: object): value is IAccountCategoryDto {
    return true;
}

export function IAccountCategoryDtoFromJSON(json: any): IAccountCategoryDto {
    return IAccountCategoryDtoFromJSONTyped(json, false);
}

export function IAccountCategoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountCategoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IAccountCategoryDtoToJSON(json: any): IAccountCategoryDto {
    return IAccountCategoryDtoToJSONTyped(json, false);
}

export function IAccountCategoryDtoToJSONTyped(value?: IAccountCategoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

